<template>
  <div id="app">
    <router-view :key="$route.fullPath"/>
  </div>
</template>
<script>
export default {
  data () {
    return {
      languageType: "cn"
    }
  },
  created () {
    this.setEnv()
    this.setBgColor()
  },
  methods: {
    setEnv() {
      if (this.$utils.isWeiXin()) {
        this.$utils.isInMiniprogram().then(res => {
          this.$store.commit('changeMiniEnv', res)
        })
      } else {
        this.$store.commit('changeMiniEnv', false)
      }
    },
    setBgColor() {
      let bgcolor = this.getUrlKey("bgcolor");
      this.languageType = this.$route.query.languageType;
      this.$i18n.locale = this.getUrlKey("languageType") || 'cn';
      if (bgcolor) {
        document.getElementsByTagName('body')[0].style.setProperty('--bgcolor', "#" + this.getUrlKey("bgcolor"))
        window.bgcolor = "#" + this.getUrlKey("bgcolor");
      }
    },
    getUrlKey (name) {
      if(window.location.href.indexOf('?')==-1 || window.location.href.indexOf(name)==-1){
        return ''
      }
      let bgcolor = decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [""])[1].replace(/\+/g, '%20')) || null;
      console.log(bgcolor,'888');
      if (!bgcolor) {
        return '';
      }
      return bgcolor.replace(/\//g, '')
    },
    getURLParams(name) {
      const url = window.location.href
      const start = url.indexOf('?')
      const end = url.indexOf('#/')

      let urlQuery = ''
      if (start !== -1) {
        if (start < end) {
          urlQuery = url.substring(start, end).slice(1)
        } else {
          const hash = window.location.hash
          const query = hash.split('?')
          urlQuery = query[1].slice(0)
        }

        const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
        const r = urlQuery.match(reg)
        if (r != null) {
          return decodeURIComponent(r[2])
        }
        return null
      }

      return ''
    }
  }
}
</script>
<style>
@import "styles/base.scss";

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.show-3{
  word-break:break-all;
  display:-webkit-box;
  -webkit-line-clamp:3;
  -webkit-box-orient:vertical;
  overflow:hidden;
}
.show-2{
  word-break:break-all;
  display:-webkit-box;
  -webkit-line-clamp:2;
  -webkit-box-orient:vertical;
  overflow:hidden;
}
.i-interactor-wrap-en .van-field__value{
  padding:0 15px;
}
.news-details img {
  width: auto;
  max-width: 100%;
  height: auto;
}
.jr-h5-details img {
  width: auto;
  max-width: 100%;
  height: auto;
  display: block;
}
.jr-h5-details p{
  margin: 0px;
  padding: 0px;
}
</style>
